import Head from "layout/Head";
import React from "react";

import { PhysicalSecurityBullet } from "@ubnt/store.core/lib/constants/modelCompareData/data/PhysicalSecurityBullet";
import { useTranslation as useTranslationGlobal } from "hooks/useTranslation";
import { Hero } from "pages/LayoutComponents/Hero";
import { FEATURE_COMPLETE_TILES, HERO_SECTIONS } from "./Bullet.config";
import { useSiteSettings } from "context/SiteSettingsContext";
import { ChildPage } from "components/ChildPage";
import { INSTALLATION_ADDONS } from "../config/InstallationAddons.config";
import { ProductListGroupId } from "@ubnt/store.core/lib/constants/modelCompareData/types";

export const Bullet = () => {
  const { routes } = useSiteSettings();
  const { t } = useTranslationGlobal();

  return (
    <>
      <Head
        title={t("cameraSecurity.bullet.seo.title")}
        description={t("cameraSecurity.bullet.seo.description")}
        url="https://ui.com/physical-security/bullet"
        image="https://www.ui.com/microsite/og-image.physical-security.jpg"
      />

      <Hero
        title={t("cameraSecurity.bullet.hero.title")}
        sections={HERO_SECTIONS}
        buyButton={{
          href: routes.store.category("cameras-bullet"),
        }}
      />

      <ChildPage
        defaultCompareSection={PhysicalSecurityBullet}
        featureCards={FEATURE_COMPLETE_TILES}
        installationAddonsConfig={INSTALLATION_ADDONS}
        groupId={ProductListGroupId.Bullet}
      />
    </>
  );
};
